module.exports = __webpack_public_path__ + "assets/img/kt-renewed-5.0cc0121a.png";